import script from "./AppPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppPicker.vue?vue&type=script&setup=true&lang=ts"

import "./AppPicker.vue?vue&type=style&index=0&id=7c4afb2d&scoped=true&lang=scss"

import exportComponent from "/home/dorian/programy/vue-draft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4afb2d"]])

export default __exports__